<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Examination Mark Sheet</h5>

    <form class="mr-0" (ngSubmit)="getResultReport()" *ngIf="!exportedFile.file">
      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Sort By</label>
          <ng-select class="form-select" [(ngModel)]="resultReport.sortBy" [ngModelOptions]="{ standalone: true }">
            <ng-option selected value="" disabled selected>NotSet</ng-option>
            <ng-option selected value="CandidateNo">Candidate Number (Ascending)</ng-option>
            <ng-option selected value="Name">Name (Ascending)</ng-option>
            <ng-option selected value="Score">"Score (Descending)"</ng-option>
          </ng-select>

        </div>
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Date Of Writing</label>
          <input class="form-control" type="date" [(ngModel)]="resultReport.dateOfWriting"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>
      <div class="mb-3 mr-0 col-md-12">
        <label class="form-label">Candidate Number List</label>
        <textarea class="form-control" rows="2" [(ngModel)]="resultReport.candidateNoList"
          [ngModelOptions]="{ standalone: true }"></textarea>
      </div>


      <div class="row">
        <div class="mb-3 mr-0 col-md-4">
          <div class="form-check mb-3 mr-0 col-md-12">
            <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.writtenOnly"
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label" for="flexCheckDefault">
              Written Only
            </label>
          </div>
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <div class="form-check mb-3 mr-0 col-md-12">

            <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.skipImportCandidateData"
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label">Skip Import Candidate Data</label>

          </div>
        </div>
          <div class="mb-3 mr-0 col-md-4">
            <div class="form-check mb-3 mr-0 col-md-12">
              <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.excludeTestCandidates"
                [ngModelOptions]="{ standalone: true }">
              <label class="form-check-label" for="flexCheckDefault">
                Exclude Test Candidates
              </label>
            </div>
          </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-12" type="submit"> Generate Report
      </button>
    </form>
    <app-file-download *ngIf="exportedFile.file" [exportedFile]="exportedFile"></app-file-download>
  </div>
</div>